import { useRef, useState } from "react";
import { Html } from "@react-three/drei";

import Point from "../Points/Point";
import { points } from "../../constants/points";
import { useSection, useTheme } from "../../common/hooks";

export function PointWraper({ children, ...props }) {
  // This holds the visible state
  const [hidden, set] = useState();

  return (
    <Html
      occlude
      // The <Html> component can tell us when something is occluded (or not)
      onOcclude={set}
      // We just interpolate the visible state into css opacity and transforms
      style={{
        transition: "all 0.2s",
        opacity: hidden ? 0 : 1,
        transform: `scale(${hidden ? 0.25 : 1})`,
      }}
      {...props}
    >
      {children}
    </Html>
  );
}

export default function Points(props) {
  const group = useRef();
  const { currentSection, visited, setSection } = useSection();
  const { theme } = useTheme();

  return (
    <group ref={group} {...props} dispose={null} name="points">
      {points.map((point, i) => (
        <mesh name={point.name} key={i} position={point.position}>
          <PointWraper>
            <Point
              point={point}
              currentSection={currentSection}
              setSection={setSection}
              visited={visited}
              theme={theme}
            />
          </PointWraper>
        </mesh>
      ))}
    </group>
  );
}
